export default "__VITE_PUBLIC_ASSET__b8786513__"